import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

export default function Articles() {
  const latestArticles = articles.slice(0, 6);

  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '征途国际攻略资讯',
      description: '征途国际最新游戏攻略、新闻资讯、官方公告汇总',
      url: 'https://ztroute.github.io/articles',
    },
  ];

  return (
    <>
      <SEOHead
        title="征途国际攻略资讯-最新游戏攻略与新闻 | 征途国际官方下载站"
        description="征途国际最新游戏攻略、新闻资讯、官方公告汇总。获取最全面的征途国际游戏攻略、职业解析、版本更新信息。"
        keywords="征途国际攻略,征途国际新闻,征途国际资讯,征途国际最新消息"
        canonicalUrl="https://ztroute.github.io/articles"
        schemaData={schemaData}
      />
      <Navbar />
      <main className="pt-20 pb-14 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '攻略资讯' },
            ]}
          />

          <header className="mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              攻略资讯
            </h1>
            <p className="text-foreground-600 text-sm md:text-base">
              掌握征途国际最新动态，学习高手进阶攻略
            </p>
          </header>

          <div className="flex flex-wrap items-center gap-2 mb-10">
            <Link
              to="/categories"
              className="px-4 py-2 bg-secondary-100 text-secondary-700 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              按分类浏览
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to="/categories"
                className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
            {latestArticles.map((article) => {
              const cat = categories.find((c) => c.id === article.category);
              return (
                <Link
                  key={article.id}
                  to={`/articles/${article.slug}`}
                  className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
                >
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full font-medium">
                        {cat?.name || article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {article.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}